// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"300":"bfb5ca4f","659":"3e99815c"}[chunkId] + ".js";
};